import { GameQuestionCanYouPan } from "shared/games/types/GameQuestions";
import { PlaybackState } from "../pages/CanYouPanGame";
import GameBoxWithTitle from "ui/atoms/GameBoxWithTitle";
import useMeasure from "util/useMeasure";
import PanKnob from "../molecules/PanKnob/PanKnob";
import { useLockedBody } from "usehooks-ts";
import { refrenceTrackIds } from "../pages/referenceTrackConfig";

interface Props {
  pan: number;
  setPan: (volume: number) => void;
  playbackState: PlaybackState | "failed";
  question: GameQuestionCanYouPan;
}

export default function CanYouPanGameTemplate(props: Props) {
  const [, setLocked] = useLockedBody(false);
  const [{ width }, ref] = useMeasure<HTMLDivElement>({
    key: "can-you-pan",
  });

  return (
    <GameBoxWithTitle title={<GameTitle {...props} />} heightClassName="">
      <div
        id={refrenceTrackIds.graph}
        className={"mx-auto w-72 pb-10 sm:w-80 md:w-[500px]"}
        ref={ref}
        onTouchStart={() => setLocked(true)}
        onTouchEnd={() => setLocked(false)}
      >
        <PanKnob
          width={width}
          step={props.question.panDegreeSteps}
          pan={props.pan}
          setPan={props.setPan}
          failed={props.playbackState === "failed"}
        />
      </div>
    </GameBoxWithTitle>
  );
}

function GameTitle({ playbackState }: Props) {
  if (playbackState === "failed") {
    return <span className={"text-red-500"}>Incorrect!</span>;
  }

  if (playbackState === "mix") {
    return (
      <span>
        Listening to <span className={"text-purple-400"}>Your Mix</span>
      </span>
    );
  }

  return (
    <span>
      Listening to the <span className={"text-purple-400"}>Reference</span>
    </span>
  );
}
